import { searchAlignmentStyles } from '../../api/alignment-styles.api';
import { SearchAlignmentStylesApiRequest } from '../../../../types/requests/alignment-styles/search-alignment-styles.request';
import { useAxiosInfiniteQuery } from './use-axios.hook';

const baseQueryKey = 'alignment-style';
const searchQueryKey = 'search';

export const useSearchAlignmentStyles = (params: SearchAlignmentStylesApiRequest) => {
  const { data, ...result } = useAxiosInfiniteQuery({
    queryKey: [baseQueryKey, searchQueryKey, params],
    queryFn: async ({ pageParam }) => (await searchAlignmentStyles({ cursor: pageParam, ...params })).data,
    initialPageParam: params.cursor,
    getNextPageParam: (lastResponse) => lastResponse.nextCursor,
  });
  return { ...result, response: data } as const;
};
